module.exports = __webpack_public_path__ + "static/media/loader.c931c642.svg";